import API from '@/assets/libraries/API_Requests';

export async function getVersionDetails(build_type = 'current') {
	try {
		const response = await API.Call('GET', `${API.CSC_API_URL}/versions/${build_type}`);
		return response;
	} catch (error) {
		throw new Error(JSON.stringify(error));
	}
}

export function getBrowserVersion(user_agent = window.navigator.userAgent) {
	const match = user_agent.match(/(Chrome|Firefox|Safari|Edge|MSIE|Trident)[ /](\d+(\.\d+)?)/i);
	if (match) {
		return match.slice(1).join(' ');
	}
	return 'Unknown';
}

export function getOSVersion(user_agent = window.navigator.userAgent) {
	if (user_agent.indexOf('Windows') > -1) {
		return 'Windows';
	} else if (user_agent.indexOf('Mac') > -1) {
		return 'Mac OS';
	} else if (user_agent.indexOf('X11') > -1) {
		return 'UNIX';
	} else if (user_agent.indexOf('Linux') > -1) {
		return 'Linux';
	} else {
		return 'Unknown';
	}
}
